module.exports = __webpack_public_path__ + "static/media/salvador.635cdf7b.jpg";